module.exports = __webpack_public_path__ + "img/03-11.d44aa783.png";